// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Y89r","signatureBlock":"Footer_signatureBlock__vvOSY","signature":"Footer_signature__3Sl1j"};